import { render, staticRenderFns } from "./high-end-hotel-development-in-south-east-london.vue?vue&type=template&id=3b6b0aa7&"
import script from "./high-end-hotel-development-in-south-east-london.vue?vue&type=script&lang=js&"
export * from "./high-end-hotel-development-in-south-east-london.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports